var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatternDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(-135 -34)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(135 34)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E4E1",
    d: "M0 45.73324L25.00891 60.01812 16.84958 45.73324 25.00891 31.44696z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A18292",
    d: "M60.01766 25.00937L45.73137 0 31.44696 25.00937 45.73137 16.84958z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9DB6AF",
    d: "M31.44696 66.45524L45.73137 91.46461 60.01766 66.45524 45.73137 74.61503z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2986B",
    d: "M66.4557 31.44696L74.61503 45.73324 66.4557 60.01812 91.46461 45.73324z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternDots);
export default __webpack_public_path__ + "static/media/pattern-dots.7403b3d52117db99f56b5ad43477129f.svg";
export { ForwardRef as ReactComponent };